import clsx from "clsx";
import type React from "react";

type Props = React.PropsWithChildren &
	React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> & {
		pageName: string;
	};

export default function Main({
	children,
	className,
	pageName,
	...props
}: Props) {
	return (
		<main
			id="site-main"
			className={clsx("site-main flex flex-col", className)}
			data-spec-page={pageName}
			{...props}
		>
			{children}
		</main>
	);
}
